export const DATE_FORMAT = {
  'DD.MM.YYYY': 'de-DE',
  // 'MM.DD.YYYY': 'MM.DD.YYYY', Removed because it's not supported by Intl.DateTimeFormat.
  'DD/MM/YYYY': 'en-GB',
  'MM/DD/YYYY': 'en-US'
  // 'MM/DD/YY': 'en-US-2'
} as const

export type DateFormat = (typeof DATE_FORMAT)[keyof typeof DATE_FORMAT]
